import { render, staticRenderFns } from "./reportFrom.vue?vue&type=template&id=1bcaf78a&scoped=true&"
import script from "./reportFrom.vue?vue&type=script&lang=js&"
export * from "./reportFrom.vue?vue&type=script&lang=js&"
import style0 from "./reportFrom.vue?vue&type=style&index=0&id=1bcaf78a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcaf78a",
  null
  
)

export default component.exports